import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions } from './details-form-helpers';

/**
 * SECTION 4.5: CO-APPLICANT EMPLOYMENT INFORMATION
 */
export function getCoApplicantEmploymentFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    // Employment
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Employer',
          type: 'input',
          props: {
            label: 'Employer',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Secondary_Position',
          type: 'input',
          props: {
            label: 'Position',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Status',
          type: 'select',
          props: {
            label: 'Employment Status',
            options: toFormlyOptions(options.employmentStatuses$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Secondary_Work_Number',
          type: 'phone',
          props: {
            label: 'Work Phone',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: '_coApplicantEmploymentYears',
          type: 'input',
          props: {
            label: 'Employment Years',
            type: 'number',
            min: 0,
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: '_coApplicantEmploymentMonths',
          type: 'input',
          props: {
            label: 'Employment Months',
            type: 'number',
            min: 0,
            max: 11,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Pay_Frequency',
          type: 'select',
          props: {
            label: 'Pay Frequency',
            options: toFormlyOptions(options.payFrequencies$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Sec_Annual_Income',
          type: 'currency',
          props: {
            label: 'Annual Income',
          },
        },
      ],
    },
  ];
}